import { DEFAULT_COUNTRY_CODE } from "@dtm-frontend/shared/utils";

export const LOCAL_PILOT_NUMBER_PREFIX = DEFAULT_COUNTRY_CODE;
export const PILOT_NUMBER_COUNTRY_START_INDEX = 0;
export const PILOT_NUMBER_COUNTRY_END_INDEX = 2;
